import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices";

const DashboardInvoicesMini = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const response =
        await ajaxSupplierInvoices.fetchSupplierInvoicesWz_balances({});
      if (response.status === "OK") {
        // Filter pending invoices and show only first 8
        const pendingInvoices = response.details
          .filter((inv) => parseFloat(inv.balance) > 0)
          .slice(0, 8);
        setInvoices(pendingInvoices);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <div className="card shadow-sm mb-3">
      <div className="card-header bg-light fw-bold">
        Pending Supplier Invoices
      </div>
      <div className="card-body p-0">
        <Toaster />
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Invoice No</th>
                <th>Supplier</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center py-3">
                    Loading invoices...
                  </td>
                </tr>
              ) : invoices.length > 0 ? (
                invoices.map((inv, idx) => (
                  <tr key={inv.id}>
                    <td>{idx + 1}</td>
                    <td>{inv.invoice_no}</td>
                    <td>{inv.buss_name}</td>
                    <td>
                      <span className="badge bg-warning text-dark">
                        {parseFloat(inv.balance).toLocaleString()}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-3">
                    No pending invoices
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="card-footer text-center">
        <button
          className="btn btn-sm btn-primary"
          onClick={() => navigate("/supplier_invoices/invoice_with_balances")}
        >
          View All
        </button>
      </div>
    </div>
  );
};

export default DashboardInvoicesMini;
